var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"device-container"},[_c('div',{ref:"myMap",staticStyle:{"width":"100vw","min-height":"80vh","height":"90vh"},attrs:{"id":"myMap"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }